export default {
    getContrastYIQ(hexcolor) {
        var r = parseInt(hexcolor.substr(0,2),16);
        var g = parseInt(hexcolor.substr(2,2),16);
        var b = parseInt(hexcolor.substr(4,2),16);
        var yiq = ((r*299)+(g*587)+(b*114))/1000;
        return (yiq >= 128) ? '-dark' : '-light';
    },
    componentFromStr(numStr, percent) {
        var num = Math.max(0, parseInt(numStr, 10));
        return percent ?
            Math.floor(255 * Math.min(100, num) / 100) : Math.min(255, num);
    },
    rgbToHex(rgb) {
        var rgbRegex = /^rgb\(\s*(-?\d+)(%?)\s*,\s*(-?\d+)(%?)\s*,\s*(-?\d+)(%?)\s*\)$/;
        var result, r, g, b, hex = "";
        if ( (result = rgbRegex.exec(rgb)) ) {
            r = this.componentFromStr(result[1], result[2]);
            g = this.componentFromStr(result[3], result[4]);
            b = this.componentFromStr(result[5], result[6]);

            hex = (0x1000000 + (r << 16) + (g << 8) + b).toString(16).slice(1);
        }
        return hex;
    },
    init() {
        var self = this;
        var rotate = {
            init: function() {
                rotate.$elems = $(".js-rotate");
                rotate.total = rotate.$elems.length;
                rotate.position = 0;
                rotate.$elems.hide();
                rotate.$elems.eq(0).show();
                setInterval(rotate.change, 8000);
            },
            change: function() {
                rotate.$elems.eq(rotate.position).fadeOut('slow', function() {
                    rotate.position++;
                    if (rotate.position == rotate.total) {
                        rotate.position = 0;
                    }
                    rotate.$elems.eq(rotate.position).fadeIn('slow');
                });
            },
        }
        var work = {
            setBgColors: function() {
                work.$list.each(function(index, el) {
                    if ($(el).data('color')) {
                        return true;
                    }
                    var image = $(el).find(".image");
                    image.primaryColor(function(color) {
                        $(el).data('color', color);
                    });
                });
            },
            init: function() {
                work.$html = $("html");
                work.$parent = $(".js-work");
                work.$header = $(".js-header");
                work.$list = work.$parent.find(".js-work--item");
                work.setBgColors();
                $(".grid").on("mouseover", ".js-work--item", work.mouseEnter);
                $(".grid").on("mouseleave", ".js-work--item", work.mouseLeave);
            },
            mouseEnter: function( event ) {
                var el = $(this);
                var color = el.data("color");
                work.$list.not(el).addClass("is--overlay");
                if (color) {
                    var hexcolor = self.rgbToHex('rgb('+color+')');
                    work.$html.css("background-color", "rgb("+color+")");
                    work.$header.css("background-color", "rgba("+color+", 0.8)");
                    work.$html.addClass(self.getContrastYIQ(hexcolor));
                }
            },
            mouseLeave: function( event ) {
                work.$html.removeAttr("style");
                work.$header.css("background-color", "");
                work.$html.removeClass('-light -dark');
                work.$list.removeClass("is--overlay");
            },
        };
        rotate.init();
        work.init();
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js